export default {
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes.',
    successfully_saved: 'Gemt.',
  },
  form: {
    has_multiple_locations: {
      label: 'Angiv forskellige lokationer for ugen',
    },
  },
  labels: {
    day_location: '{{day}} lokation {{index}}',
    selected_days: 'Valgte dage',
    orders_paused: 'Ordrer sat på pause',
    open_time: 'Åbningstid',
    close_time: 'Lukketid',
  },
  buttons: {
    save: 'Gem',
  },
};
